import React from 'react';
import { InView } from 'react-intersection-observer';
import { useTracking } from 'react-tracking';
import { makeStyles } from 'src/makeStyles';
import { trackImpression } from '../blitzerTracking';

const useStyles = makeStyles()(() => ({
  wrapper: {
    display: 'block',
    width: 'inherit',
  },
}));

const ImpressionTracker = props => {
  const tracking = useTracking();
  const { classes, cx } = useStyles();
  const { data, eventType, entity } = props;
  return (
    <InView
      as={props.as || 'div'}
      triggerOnce="true"
      onChange={(inView, entry) => {
        if (inView) {
          tracking.trackEvent(trackImpression(eventType, entity, data));
        }
      }}
      className={props.className}
    >
      {props.children}
    </InView>
  );
};

ImpressionTracker.propTypes = {};

export default ImpressionTracker;
